

export const styles: Record<string, React.CSSProperties> = {
  root: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
    position: 'relative',
    zIndex: 1,
  },
  sidebar: {
    width: 280,
    minWidth: 280,
    background: 'var(--bg2)',
    borderRight: '1px solid var(--border)',
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
    overflow: 'visible',
    transition: 'width 0.18s, min-width 0.18s',
  },
  logoArea: {
    padding: '18px 18px 14px',
    borderBottom: '1px solid var(--border)',
  },
  logoRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    justifyContent: 'space-between',
  },
  feedbackCard: {
    margin: '8px 14px 14px',
    padding: 14,
    background: 'var(--accent-d)',
    border: '1px solid color-mix(in srgb, var(--accent-fill) 20%, transparent)',
    borderRadius: 8,
    flexShrink: 0,
  },
  feedbackCardTitle: {
    fontFamily: 'var(--head)',
    fontSize: '0.78rem',
    fontWeight: 700,
    color: 'var(--text)',
    marginBottom: 4,
  },
  feedbackCardText: {
    fontFamily: 'var(--body)',
    fontSize: '0.72rem',
    color: 'var(--text2)',
    lineHeight: 1.5,
    marginBottom: 10,
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    fontFamily: 'var(--head)',
    fontWeight: 800,
    fontSize: '1rem',
    letterSpacing: '-0.02em',
    color: 'var(--text)',
    textDecoration: 'none',
  },
  logoMark: {
    width: 28,
    height: 28,
    borderRadius: 5,
    background: 'linear-gradient(135deg, #e27dff, #8c25ea 55%, #5b0fa8)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.8rem',
    fontWeight: 800,
    color: 'var(--accent-on)',
    fontFamily: 'var(--head)',
    flexShrink: 0,
  },
  nav: {
    flex: 1,
    overflow: 'auto',
    padding: '12px 0',
  },
  navSection: {
    padding: '0 10px',
  },
  navLabel: {
    fontFamily: 'var(--mono)',
    fontSize: '0.58rem',
    letterSpacing: '0.1em',
    color: 'var(--text3)',
    padding: '6px 8px 4px',
    textTransform: 'uppercase',
  },
  navItem: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '7px 10px',
    borderRadius: 5,
    fontFamily: 'var(--mono)',
    fontSize: '0.7rem',
    letterSpacing: '0.04em',
    color: 'var(--text2)',
    textDecoration: 'none',
    transition: 'all 0.15s',
    marginBottom: 2,
  },
  navItemActive: {
    background: 'var(--accent-d)',
    color: 'var(--accent)',
    borderLeft: '2px solid var(--accent)',
    paddingLeft: 8,
  },
  navItemCollapsed: {
    justifyContent: 'center',
    gap: 0,
    padding: '9px 0',
  },
  collapseRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '0 14px 4px',
    flexShrink: 0,
  },
  navDivider: {
    height: 1,
    background: 'var(--border)',
    margin: '8px 10px',
  },
  navDividerSubtle: {
    height: 1,
    background: 'var(--border)',
    opacity: 0.4,
    margin: '6px auto',
    width: '40%',
  },
  navSkeleton: {
    height: 28,
    borderRadius: 5,
    background: 'var(--bg3)',
    margin: '3px 8px',
  },
  navItemHover: {
    background: 'var(--bg3)',
    color: 'var(--text)',
  },
  avatarBtn: {
    background: 'var(--bg2)',
    border: '1px solid var(--border)',
    borderRadius: 20,
    padding: '4px 10px 4px 4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    transition: 'border-color 0.15s, background 0.15s',
  },
  avatarBtnHover: {
    borderColor: 'var(--accent)',
    background: 'var(--bg3)',
  },
  avatarName: {
    fontFamily: 'var(--mono)',
    fontSize: '0.7rem',
    color: 'var(--text)',
    maxWidth: 140,
    overflow: 'hidden' as const,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
  },
  avatarChevron: {
    fontSize: '0.6rem',
    color: 'var(--text3)',
    lineHeight: 1,
  },
  userAvatar: {
    width: 30,
    height: 30,
    borderRadius: '50%',
    background: 'var(--accent-d)',
    border: '1px solid var(--border)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'var(--head)',
    fontWeight: 700,
    fontSize: '0.75rem',
    color: 'var(--accent)',
    flexShrink: 0,
  },
  dropdown: {
    position: 'absolute' as const,
    top: 'calc(100% + 8px)',
    right: 0,
    minWidth: 220,
    background: 'var(--bg2)',
    border: '1px solid var(--border)',
    borderRadius: 6,
    boxShadow: '0 12px 32px rgba(0,0,0,0.6)',
    zIndex: 'var(--z-overlay)',
    overflow: 'hidden',
  },
  dropdownHeader: {
    padding: '12px 14px',
  },
  dropdownName: {
    fontSize: '0.8rem',
    fontWeight: 600,
    color: 'var(--text)',
    marginBottom: 2,
  },
  dropdownEmail: {
    fontFamily: 'var(--mono)',
    fontSize: '0.65rem',
    color: 'var(--text3)',
  },
  dropdownDivider: {
    height: 1,
    background: 'var(--border)',
  },
  dropdownSection: {
    padding: '8px 0 4px',
  },
  dropdownSectionLabel: {
    padding: '0 14px 4px',
    fontFamily: 'var(--mono)',
    fontSize: '0.58rem',
    letterSpacing: '0.1em',
    textTransform: 'uppercase' as const,
    color: 'var(--text3)',
  },
  dropdownLink: {
    display: 'block',
    padding: '7px 14px',
    fontFamily: 'var(--mono)',
    fontSize: '0.7rem',
    color: 'var(--text2)',
    textDecoration: 'none',
  },
  dropdownItem: {
    display: 'block',
    width: '100%',
    padding: '9px 14px',
    background: 'transparent',
    border: 'none',
    textAlign: 'left' as const,
    fontFamily: 'var(--mono)',
    fontSize: '0.7rem',
    color: 'var(--text2)',
    cursor: 'pointer',
  },
  dropdownItemHover: {
    background: 'var(--bg3)',
    color: 'var(--text)',
  },
  soonBadge: {
    display: 'inline-block',
    marginLeft: 8,
    fontSize: '0.55rem',
    fontFamily: 'var(--mono)',
    letterSpacing: '0.06em',
    textTransform: 'uppercase' as const,
    padding: '1px 5px',
    borderRadius: 3,
    background: 'var(--accent-d)',
    color: 'var(--accent)',
    border: '1px solid color-mix(in srgb, var(--accent-fill) 20%, transparent)',
    verticalAlign: 'middle',
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  topbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 28px',
    height: 56,
    background: 'var(--topbar-bg, rgba(7,9,13,0.93))',
    backdropFilter: 'blur(14px)',
    borderBottom: '1px solid var(--border)',
    flexShrink: 0,
    position: 'relative' as const,
    zIndex: 200,
  },
  topbarTitle: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontFamily: 'var(--head)',
    fontSize: '1rem',
    fontWeight: 700,
    letterSpacing: '-0.02em',
    color: 'var(--text)',
    minWidth: 0,
  },
  topbarRight: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    position: 'relative' as const,
  },
  topbarActions: {
    // display is owned by CSS (.app-topbar-actions) so the <1024px media query
    // can hide/show the dropdown. An inline `display` would beat the stylesheet
    // and strand the mobile menu permanently open.
    alignItems: 'center',
    gap: 8,
  },
  themeToggle: {
    background: 'transparent',
    border: '1px solid var(--border)',
    borderRadius: 6,
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.85rem',
    color: 'var(--text2)',
    cursor: 'pointer',
    transition: 'border-color 0.15s, color 0.15s',
  },
  content: {
    flex: 1,
    overflow: 'auto',
    padding: '24px 28px',
  },
  // Paired with Layout's `fillHeight`. overflow:hidden hands scrolling to whichever child
  // wants it, and minHeight:0 is what actually lets this box shrink to the leftover space
  // instead of being sized by its content.
  contentFill: {
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  searchBox: {
    background: 'var(--bg3)',
    border: '1px solid var(--border2)',
    borderRadius: 6,
    padding: '5px 10px',
    color: 'var(--text)',
    fontFamily: 'var(--body)',
    fontSize: '0.78rem',
    outline: 'none',
    transition: 'width 0.2s, border-color 0.15s',
  },
  searchDropdown: {
    position: 'absolute' as const,
    top: 'calc(100% + 6px)',
    right: 0,
    // Anchored right so it never runs off the viewport. Inside the mobile burger menu the
    // panel must also clear the 64px icon rail on the left (<main> is overflow:hidden, so
    // anything under the rail is clipped) plus the 28px topbar + 12px menu padding on the
    // right - hence -120px. Desktop (>=1024px) still gets the full 440.
    width: 'min(440px, calc(100vw - 120px))',
    maxHeight: '70vh',
    display: 'flex',
    flexDirection: 'column' as const,
    background: 'var(--bg2)',
    border: '1px solid var(--border)',
    borderRadius: 6,
    boxShadow: 'var(--shadow-md)',
    zIndex: 'var(--z-dropdown)',
    overflow: 'hidden',
  },
  searchHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
    padding: '6px 12px',
    borderBottom: '1px solid var(--border)',
    fontFamily: 'var(--mono)',
    fontSize: '0.66rem',
    color: 'var(--text3)',
    flexShrink: 0,
  },
  searchKbdHint: {
    whiteSpace: 'nowrap' as const,
    opacity: 0.8,
  },
  searchError: {
    padding: '8px 12px',
    fontFamily: 'var(--mono)',
    fontSize: '0.7rem',
    color: 'var(--red)',
    borderBottom: '1px solid var(--border)',
  },
  searchList: {
    overflowY: 'auto' as const,
    flex: 1,
    minHeight: 0,
  },
  searchOption: {
    padding: '8px 12px 8px 10px',
    // Longhands, not the `borderLeft` shorthand: the active style overrides only the
    // colour, and React can't diff a shorthand against a longhand across re-renders.
    borderLeftWidth: 2,
    borderLeftStyle: 'solid' as const,
    borderLeftColor: 'transparent',
    borderBottom: '1px solid var(--border)',
    cursor: 'pointer',
    minWidth: 0,
  },
  searchOptionActive: {
    background: 'var(--bg3)',
    borderLeftColor: 'var(--accent)',
  },
  searchOptionTop: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between',
    gap: 8,
    minWidth: 0,
  },
  searchOptionName: {
    fontFamily: 'var(--mono)',
    fontSize: '0.78rem',
    color: 'var(--text)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
    minWidth: 0,
  },
  searchOptionNs: {
    color: 'var(--text3)',
  },
  searchOptionVersion: {
    fontFamily: 'var(--mono)',
    fontSize: '0.72rem',
    color: 'var(--green)',
    flexShrink: 0,
  },
  searchOptionDesc: {
    marginTop: 2,
    fontFamily: 'var(--body)',
    fontSize: '0.72rem',
    color: 'var(--text2)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap' as const,
  },
  searchOptionDescEmpty: {
    marginTop: 2,
    fontFamily: 'var(--body)',
    fontSize: '0.72rem',
    color: 'var(--text3)',
    fontStyle: 'italic',
  },
  searchStats: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap' as const,
    gap: 8,
    marginTop: 5,
    fontFamily: 'var(--mono)',
    fontSize: '0.66rem',
    color: 'var(--text3)',
  },
  searchStat: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 3,
  },
  searchFooterLink: {
    display: 'block',
    padding: '7px 12px',
    fontFamily: 'var(--mono)',
    fontSize: '0.68rem',
    color: 'var(--accent)',
    textDecoration: 'none',
    borderTop: '1px solid var(--border)',
    flexShrink: 0,
  },
  searchEmpty: {
    padding: '8px 12px 10px',
    fontFamily: 'var(--body)',
    fontSize: '0.72rem',
    color: 'var(--text3)',
  },
}

